"use client";
// «Mi visita (n)» del encabezado: la única entrada al plan del día y al pago conjunto de tours.
// Cuenta las actividades del plan y los tours por pagar que no estén ya en él; abre el panel lateral de Mi visita.
import { useEffect, useState } from "react";
import { EVENTO_CARRITO, idVisitaDe, leerCarrito } from "@/lib/carrito";
import { EVENTO_ITINERARIO, leerItinerario } from "@/lib/itinerario";

export const EVENTO_ABRIR_VISITA = "sierra-tours-abrir-visita";

export function InsigniaCarrito({ idioma }: { idioma: "es" | "en" }) {
  const [n, setN] = useState(0);
  useEffect(() => {
    const leer = () => {
      const plan = leerItinerario(), ids = new Set(plan.map((x) => x.id));
      setN(plan.length + leerCarrito().filter((l) => !ids.has(idVisitaDe(l))).length);
    };
    leer();
    for (const e of [EVENTO_CARRITO, EVENTO_ITINERARIO, "storage"]) window.addEventListener(e, leer);
    return () => { for (const e of [EVENTO_CARRITO, EVENTO_ITINERARIO, "storage"]) window.removeEventListener(e, leer); };
  }, []);
  if (!n) return null;
  const es = idioma === "es";
  return (
    <a className="nav-carrito" href={`/${idioma}/itinerario`} aria-label={`${es ? "Mi visita" : "My visit"}: ${n}`}
      onClick={(e) => { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); window.dispatchEvent(new Event(EVENTO_ABRIR_VISITA)); }}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M4 6h16v14H4zM4 10h16M8 3v4M16 3v4" /></svg>
      <span className="nav-carrito-texto">{es ? "Mi visita" : "My visit"}</span> <b>{n}</b>
    </a>
  );
}
